export enum SubmissionState {
    inReview = 'InReview',
    rejected = 'Rejected',
    approved = 'Approved',
    unpublished = 'Unpublished',
}
